/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockStatementListCtrl
 */
angular.module('mercury.modules.stock.statement')
.controller('StockStatementListCtrl', ["dialog", "$q", "reporttime", "$scope", "$state", "$stateParams", "StockSuppliers", "StockSupplierStatements", "title", function(dialog, $q, reporttime, $scope, $state, $stateParams, StockSuppliers, StockSupplierStatements, title) {
  $scope.statements = StockSupplierStatements.getAll(reporttime.start(), reporttime.end(), $stateParams.supplierId);
  $scope.supplier = StockSuppliers.get($stateParams.supplierId);

  $scope.loadingPromises = [
    $scope.statements.$promise,
    $scope.supplier.$promise
  ];

  $q.all($scope.loadingPromises)
  .then(function() {
    var pageTitle = 'Statements for ' + $scope.supplier.name + ' between ' + moment(reporttime.start()).mFormat('mediumDate') + ' and ' +
      moment(reporttime.end()).mFormat('mediumDate');

    title.set(pageTitle);
  }, function() {
    $state.go('Stock.ReportSupplier', {report: $scope.report});
  });

  $scope.report = $stateParams.report;

  $scope.startTime = reporttime.start();
  $scope.endTime = reporttime.end();

  $scope.reconciledAmount = function(statement) {
    var total = 0;
    angular.forEach(statement.purchaseOrders, function(purchaseOrder) {
      total += purchaseOrder.total;
    });
    return total;
  };

  /**
   * Delete a statement.
   *
   * @param {Object} statement - The statement model
   */
  $scope.deleteStatement = function(statement, statementIndex) {
    //Set the datestamp deleted.
    StockSupplierStatements.remove(statement)
    .then(function() {
      $scope.statements.splice(statementIndex, 1);
    });
  };

  $scope.exportToXero = function(statement) {
    var exportData = {
      type: 'statements',
      combine: true,
      ids: [statement.id],
      suppliers: statement.supplierId
    };

    $state.go('Stock.XeroPurchaseOrder', {exportData: JSON.stringify(exportData), report: $stateParams.report});
  };
}]);
